module.exports = __webpack_public_path__ + "img/dolfin-logo.27723fa8.svg";